import { Color } from '@ardoq/design-tokens';

export type FocusState = 'initial' | 'selected';

export type StepColorMap = Record<StepState, Record<FocusState, Color>>;

export enum StepState {
  ACTIVE = 'active',
  DONE = 'done',
  ERROR = 'error',
  MODIFIED = 'modified',
}

export type StrikethroughLocation = 'top' | 'bottom' | 'both';
